/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaCategory } from './CriteriaCategory';
import {
    CriteriaCategoryFromJSON,
    CriteriaCategoryFromJSONTyped,
    CriteriaCategoryToJSON,
    CriteriaCategoryToJSONTyped,
} from './CriteriaCategory';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
    CriteriaQualifierToJSONTyped,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface Criteria
 */
export interface Criteria {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id?: string | null;
    /**
     * 
     */
    category_id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     */
    category?: CriteriaCategory;
    /**
     * 
     */
    is_medication_rule?: boolean;
    /**
     * 
     */
    criteria_rank?: number;
}



/**
 * Check if a given object implements the Criteria interface.
 */
export function instanceOfCriteria(value: object): value is Criteria {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    return true;
}

export function CriteriaFromJSON(json: any): Criteria {
    return CriteriaFromJSONTyped(json, false);
}

export function CriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Criteria {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'] === undefined ? undefined : json['facility_id'] === null ? null : json['facility_id'],
        'category_id': json['category_id'] == null ? undefined : json['category_id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'category': json['category'] == null ? undefined : CriteriaCategoryFromJSON(json['category']),
        'is_medication_rule': json['is_medication_rule'] == null ? undefined : json['is_medication_rule'],
        'criteria_rank': json['criteria_rank'] == null ? undefined : json['criteria_rank'],
    };
}

export function CriteriaToJSON(json: any): Criteria {
    return CriteriaToJSONTyped(json, false);
}

export function CriteriaToJSONTyped(value?: Criteria | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'category_id': value['category_id'],
        'name': value['name'],
        'description': value['description'],
        'qualifier': CriteriaQualifierToJSON(value['qualifier']),
        'category': CriteriaCategoryToJSON(value['category']),
        'is_medication_rule': value['is_medication_rule'],
        'criteria_rank': value['criteria_rank'],
    };
}

